import * as React from 'react';
import { Box, Stack, Typography, Dialog } from '@mui/material';
import * as JSTool from '../store/JSTool';

import { settingActions } from '../store/SettingSlice';
import { useSelector, useDispatch } from 'react-redux';

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade, EffectCoverflow } from 'swiper/modules';

export default function VideoAlert(props) {

    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);

    function closeTap() {
        dispatch(settingActions.showVideoAlert(null));
    }

    return (
        <Dialog
            fullScreen={true}
            PaperProps={{
                style: {
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#00000066',
                    boxShadow: 'none',
                    padding: 0,
                    margin: 0,
                    justifyContent: 'center',
                    alignItems: 'center',
                    backdropFilter: 'blur(5px)',
                    WebkitBackdropFilter: 'blur(5px)',
                },
            }}
            maxWidth={'1000px'}
            open={settingData.showVideoAlert != null}>

            <Stack
                sx={{
                    alignItems: 'center',
                    justifyContent: 'center',
                }} >

                <Box
                    component={'img'}
                    onClick={closeTap}
                    src={JSTool.getImgPath('close1.png')}
                    sx={{
                        alignSelf: 'flex-end',
                        cursor: 'pointer',
                        width: '20px',
                        mb: 2,
                        mr: 2,
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'rotate(180deg)',
                        }

                    }} />

                {
                    (settingData.showVideoAlert != null && !JSTool.isEmpty(settingData.showVideoAlert.videoUrl)) &&
                    <Box
                        component={'video'}
                        autoPlay={true}
                        controls={true}
                        loop={true}
                        muted={false}
                        playsInline={true}
                        disablePictureInPicture={true}
                        poster={settingData.showVideoAlert != null && settingData.showVideoAlert.imgUrl}
                        src={settingData.showVideoAlert != null && settingData.showVideoAlert.videoUrl}
                        sx={{
                            width: settingData.isMobile ? 1 : '800px',
                            objectFit: 'cover',
                            zIndex: 1,
                        }} />
                }

                {
                    (settingData.showVideoAlert != null && JSTool.isEmpty(settingData.showVideoAlert.videoUrl) && !JSTool.isEmpty(settingData.showVideoAlert.imgUrl)) &&
                    <Box
                        component={'img'}
                        src={settingData.showVideoAlert != null && settingData.showVideoAlert.imgUrl}
                        sx={{
                            width: settingData.isMobile ? 1 : '800px',
                            objectFit: 'cover',
                            zIndex: 1,
                        }} />
                }

                {
                    (settingData.showVideoAlert != null && !JSTool.isEmpty(settingData.showVideoAlert.imgAry)) &&
                    <ImageSwiper />
                }

            </Stack>

        </Dialog>
    );
}


function ImageSwiper(props) {

    const [swp, setSwp] = React.useState(null);
    const settingData = useSelector(state => state.settingData);


    function leftTap() {
        if (swp) {
            swp.slidePrev();
        }
    }

    function rightTap() {
        if (swp) {
            swp.slideNext();
        }
    }

    return (
        <Stack sx={{
            flexDirection: 'row',
            alignItems: 'center',
        }}>
            <Box
                onClick={leftTap}
                component={'img'}
                src={JSTool.getImgPath('white_left.png')}
                sx={{
                    height: settingData.isMobile ? '30rem' : '40rem',
                    mr: 2,
                    objectFit: 'cover',
                    objectFit: 'cover',
                    cursor: 'pointer',
                    transitionDuration: '0.3s',
                    '&:hover': {
                        transform: 'scale(1.3)',
                    }
                }} />
            <Swiper
                style={{
                    width: settingData.isMobile ? window.innerWidth*0.8 : '800px',
                }}
                // loop={true}
                // modules={[Autoplay]}
                // autoplay={{
                //     delay: 3000, // 每隔 3 秒切换
                //     disableOnInteraction: false, // 用户交互后仍继续自动播放
                // }}
                slidesPerView={1}
                onSwiper={(swiper) => {
                    setSwp(swiper);
                    swiper.slideTo(settingData.showVideoAlert.index, 0, false);
                }}
                className="mySwiper" >

                {settingData.showVideoAlert.imgAry.map((item, index) => {
                    return <SwiperSlide key={index}> <SwiperItem item={item} /> </SwiperSlide>
                })}
            </Swiper>

            <Box
                onClick={rightTap}
                component={'img'}
                src={JSTool.getImgPath('white_right.png')}
                sx={{
                    height: settingData.isMobile ? '30rem' : '40rem',
                    ml: 2,
                    objectFit: 'cover',
                    objectFit: 'cover',
                    cursor: 'pointer',
                    transitionDuration: '0.3s',
                    '&:hover': {
                        transform: 'scale(1.3)',
                    }
                }} />
        </Stack>
    );
}

function SwiperItem(props) {
    return (
        <Stack sx={{
            position: 'relative',
            height: 1,
        }}>
            <Box component={'img'}
                src={JSTool.getImgPath(props.item)}
                sx={{
                    height: 1,
                    mx: 0.5,
                    borderRadius: '10rem',
                    bgcolor: '#ffffff',
                }} />
        </Stack>
    );
}